import { getPageList } from './startEndPages';
import { getItemText } from './getItemText';

export interface IUsePaginationProps {
  pagesTotal: number;
  pageActive: number;
  paginationWidth: number;
  onSelect(pageSelected: number): void;
}

export const usePagination = (props: IUsePaginationProps) => {
  const { onSelect, pageActive, pagesTotal, paginationWidth } = props;

  const { endPage, pagesList, startPage } = getPageList(pageActive, pagesTotal, paginationWidth);
  const handleNext = pageActive < pagesTotal ? () => onSelect(pageActive + 1) : undefined;
  const handlePrev = pageActive > 1 ? () => onSelect(pageActive - 1) : undefined;
  const getText = (pageNumber: number, itemIndex: number) =>
    getItemText({
      itemIndex,
      pageNumber,
      startPage,
      endPage,
      pagesTotal,
      pagesList,
    });

  return {
    handleNext,
    handlePrev,
    pagesList,
    getText,
  };
};
